import React from 'react'
import '../pages/pages.css'
import '../components/components.css'
import { NavLink } from 'react-router'

const projects = [
    {
        name: "furever.co",
        description: "shopify theme development with 9-birds creative, product quiz/recommendation implementation.",
        date: "oct 2025"
    },
    {
        name: "lylemcgraw.com",
        description: "shopify liquid theme development and consulting.",
        date: "may 2025"
    },
    {
        name: "drinksommer.com",
        description: "landing page development for sommer sparkling mate.",
        date: "sep 2024"
    },
    
]

const ProjectCard = ({project, number}) => {
    return (
        <div className='project-card'>
            <div className='project-card-description'>
                <a target='_blank' rel="noreferrer" href={`https://${project.name}`}><span>{project.name}</span></a>
                <span>{project.description}</span>
                <span>{project.date}</span>
                <a target='_blank' rel="noreferrer" href={`https://${project.name}`} className='view-button'>
                    VIEW PROJECT
                </a>
            </div>
        </div>
    )
}

const Development = () => {
  return (
    <div  id='development'>
        <div id='header-title'>
            <NavLink to="/">josh popp</NavLink>
        </div>
        <div className='projects'>
            {
                projects.map((project, index) => {
                    return (
                        <ProjectCard key={index} number={index + 1} project={project} />
                    )
                })
            }
        </div>
        <div>
            <span style={{marginBottom: 10}}>work in progress ...</span>
        </div>
    </div>
  )
}

export default Development